import React from 'react';
import { FormInputSt } from '../FormInputSt';

const FormInput = ({ ...rest }) => {
  return <FormInputSt {...rest} autoComplete={'off'}/>
}
export default FormInput
